export default __webpack_public_path__ + "static/media/7440edbdfc0bf0317bf05ebb6c98fa0c1581602420857.6bc33cf6.webp";